export default async synchronizer => {
    await synchronizer.$store.dispatch('xbts/fetchFeaturedPrice');
}
